
class exports.ProductWithRatings

    constructor: ->
        # tells the Factory to set whatever properties are available, instead
        # of checking for predefined ones.
        @_require_predefined_props = false

        @id = null
        @seed_company = ''
        @product_name = ''
        @trait_package = ''
        @active = true
        @is_placeable = false

        # this should be set by the controller in the loadProducts() method
        @full_name = ''

    hasTrait: (prop) =>
        return ($.isNumeric(this[prop]) and this[prop] > 5)

    updateLength: (prop) =>
        # still need the ? because null is a valid value
        length = this[prop]?.length ? ''
        if length is 0
            length = ''
        this["#{prop}_length"] = length

    getChemistryTraits: (chemistry_columns) =>
        return (prop for prop in chemistry_columns when @hasTrait(prop))

    isAValidRefugeOption: (refuge_percent_columns) =>
        # If the product is a refuge-in-bag product, it's not a refuge option.
        # This column doesn't exist yet though.
        # if @refuge_in_bag
        #     return false

        # if the product requires a refuge, it's not a valid refuge option
        # refuge_percent_columns may be refuge_percent, refuge_percent_south, or both
        for prop in refuge_percent_columns
            # if the value is invalid, it shouldn't be used as a refuge option
            if not $.isNumeric(this[prop]) or this[prop] > 0
                return false

        return true

    isAValidRefugeOptionFor: (other, chemistry_columns, refuge_percent_columns) =>
        # The chemistry_columns are passed in from the controller because they
        # change per lineup and we don't want to be checking all of them if we
        # don't have to.

        # check refuge validity
        if not @is_refuge
            return false

        # check active flag
        if other.active and not @active
            return false

        # must match at least one chemistry trait, unless the product has none
        if other.getChemistryTraits(chemistry_columns).length is 0
            chem_match = true
        else
            chem_match = false
            for prop in @getChemistryTraits(chemistry_columns)
                if other.hasTrait(prop)
                    chem_match = true
                    break
        if not chem_match
            return false

        return true

    getMissingRefugeChemistries: (refuge_products, chemistry_columns) =>
        missing_traits = []
        for prop in @getChemistryTraits(chemistry_columns)
            trait_is_matched = false
            for product in refuge_products
                if product.hasTrait(prop)
                    trait_is_matched = true
                    break
            if not trait_is_matched
                missing_traits.push(prop)

        return missing_traits
